exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-info[data-v-9650c03c]{font-size:smaller}.char-count[data-v-9650c03c]{color:#006400}.char-count-close[data-v-9650c03c]{color:#ff4500}", ""]);

// exports
